import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DownloaderFile, PpkService } from '../../../services/ppk.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-select-downloader-file-dialog',
  templateUrl: './select-downloader-file-dialog.component.html',
  styleUrls: ['./select-downloader-file-dialog.component.scss']
})
export class SelectDownloaderFileDialogComponent implements OnInit {
  isLoading = true;
  files: DownloaderFile[] = [];
  selectedFile: DownloaderFile | null = null;
  errorMsg = '';

  constructor(
    private dialogRef: MatDialogRef<SelectDownloaderFileDialogComponent>,
    private ppkService: PpkService,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.loadFiles();
  }

  loadFiles(): void {
    this.isLoading = true;
    this.errorMsg = '';
    this.ppkService.listDownloaderFiles().subscribe({
      next: (res) => {
        this.isLoading = false;
        if (res.ok) {
          this.files = res.files || [];
        } else {
          this.errorMsg = res.message || 'Failed to list files.';
        }
      },
      error: (err) => {
        this.isLoading = false;
        this.errorMsg = 'Failed to load files from server.';
        console.error(err);
      }
    });
  }

  selectFile(file: DownloaderFile): void {
    this.selectedFile = file;
  }

  onConfirm(): void {
    if (!this.selectedFile) return;
    this.dialogRef.close(this.selectedFile);
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}

